// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YxNsj","header":"Table_header__xImn-","row":"Table_row__PvTJP"};